import { BaseDataGridRequest } from '../base-data-grid.request';

export interface GetMasterPlanLocationsRequest extends BaseDataGridRequest {
  planContainerId: number;
  locationId?: string;
  locationName?: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  postalCode?: string;
  city?: string;
  country?: string;
}
